import { colors } from 'configs'

export const chartFillColors = {
  high: colors.riskIntelligence.highRisk,
  medium: colors.riskIntelligence.mediumRisk,
  low: colors.riskIntelligence.lowRisk,
}
